import Alpine from "alpinejs";
import axios from "axios";

window.Alpine = Alpine;

Alpine.start();

document.querySelectorAll(".sortable-column").forEach((item) => {
	item.addEventListener("click", (event) => {
		event.preventDefault();
		let order = item.dataset.sort;
		let dir = item.dataset.sortDir;
		let url = item.dataset.url;
		if (url.indexOf("?") < 1) {
			window.location.href = url + "?&order=" + order + "&order_dir=" + dir;
		} else {
			window.location.href = url + "&order=" + order + "&order_dir=" + dir;
		}
	});
});

window.addEventListener("DOMContentLoaded", (event) => {
	let delete_id = 0;

	const alertSuccessBox = document.querySelector(".alert-success");
	const closeSuccess = document.querySelector(".close-success");

	setTimeout(() => {
		alertSuccessBox.remove();
	}, 7500);

	closeSuccess.addEventListener("click", (event) => {
		alertSuccessBox.remove();
	});
});
